import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CheckNotaryExporter  {
    _originalTypeClassName = "zERP.BO.CheckNotaryExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CheckNotaryExporter.translate = translateService;
}
this.CheckNotaryExporterKey = null;
this._key = this.CheckNotaryExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _CheckNotaryExporterKey:any;
get CheckNotaryExporterKey(): any {
    return this._CheckNotaryExporterKey;
  }
set CheckNotaryExporterKey(value: any) {
    this._CheckNotaryExporterKey = value;
    this._key = value;
  }

static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{switch ((collectionName)) {case "CHECKS":
{
let check = Joove.Common.cast(item, "Domain.Check");switch ((varName)) {case "EXPIRY":
{
return CLMS.Framework.DateTime.ToString(check?.DateToExpire, "dd/MM/yyyy");}
case "NUMBER":
{
return check?.CheckNumber;}
case "ISSUE":
{
return CLMS.Framework.DateTime.ToString(check?.DateCreated, "dd/MM/yyyy");}
case "BANK":
{
return check?.BankAccount?.Bank?.Name;}
case "TYPE":
{
return "Επιταγή";}
case "OWNER":
{
return check?.Entity?.Name;}
case "ISSUER":
{
return check?.Beneficiary?.FullName;}
case "STATUS":
{
return (check?.IsPayed ? "Εξοφλημένο" : "Στο Χαρτοφυλάκιο");}
case "AMOUNT":
{
return check?.TotalAmount;}
case "OPEN":
{
return (check?.IsPayed ? 0 : check?.TotalAmount);}
default:
{
return null;}
}break;
}
case "TYPES":
{
switch ((varName)) {case "NAME":
{
return item;}
default:
{
return null;}
}break;
}
default:
{
return null;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CheckNotaryExporterKey == null || $this.CheckNotaryExporterKey == 0;
            }


}